import { createApi } from '@reduxjs/toolkit/query/react';
import BaseQuery from './base.api';
import type { Asset } from './models/asset.model';
import type { Invoice } from './models/invoice.model';
import type { Contract } from './models/contract.model';
import { validateBlobResponse } from '../utils/helpers';

export interface EntityData {
	selectedRecords: (Contract | Asset | Invoice)[];
	requestData: any[];
}

export interface CsrRequestPayload {
	requestType: string;
	message: string;
	contactEmail: string;
	accountName: string;
	entityData: EntityData;
}

export const csrRequestApi = createApi({
	reducerPath: 'csrRequestApi',
	baseQuery: BaseQuery('/v1/csr'),
	endpoints: (builder) => ({
		submitCsrRequest: builder.mutation<void, CsrRequestPayload>({
			async queryFn(payload, _queryApi, _extraOptions, fetchWithBQ) {
				const response = await fetchWithBQ({
					url: '',
					method: 'POST',
					body: payload,
					responseHandler: (r: Response) => r.blob(),
				});
				
				const validationResult = validateBlobResponse(response);

				if (!validationResult.error) {
					
					// Download the CSV file
					const blob = validationResult.data as Blob;
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.href = url;
					a.download = 'csr-request.csv';
					document.body.appendChild(a);
					a.click();
					a.remove();
					window.URL.revokeObjectURL(url);
					return { data: undefined };
				} 
				else {
					return { error: validationResult.error };
				}
			},
		}),
	}),
});

export const { useSubmitCsrRequestMutation } = csrRequestApi;
